<template>
  <div>
    <el-card class="box-card">
      <div slot="header" class="flex justify-between">
        <span>退货订单</span>
        <el-button
          type="primary"
          size="small"
          style="float: right;"
          @click="_openAddShopHouseModal()"
        >
          <i class="el-icon-plus"></i>选择订单
        </el-button>
      </div>
      <el-table
        :data="downShopHouseOutManageInfo.inoutOrderProducts"
        style="width: 100%"
        border
      >
        <el-table-column prop="productId" label="编号" align="center"></el-table-column>
        <el-table-column prop="prodName" label="名称" align="center"></el-table-column>
        <el-table-column prop="specName" label="规格" align="center"></el-table-column>
        <el-table-column prop="prodCount" label="进货数量" align="center"></el-table-column>
        <el-table-column label="数量" align="center">
          <template slot-scope="scope">
            <el-input
              v-model.number="scope.row.count"
              type="number"
              @input="_caculTotalMount()"
            ></el-input>
          </template>
        </el-table-column>
        <el-table-column label="单价" align="center">
          <template slot-scope="scope">
            <el-input
              v-model.number="scope.row.price"
              type="number"
              @input="_caculTotalMount()"
            ></el-input>
          </template>
        </el-table-column>
        <el-table-column label="操作" align="center">
          <template slot-scope="scope">
            <el-button
              type="text"
              size="small"
              @click="_deleteProduct(scope.row)"
            >删除</el-button>
          </template>
        </el-table-column>
      </el-table>
      <el-pagination
        layout="prev, pager, next"
        :total="total"
        :page-size="pageSize"
        @current-change="handleCurrentChange"
      ></el-pagination>
    </el-card>

    <el-card class="box-card" style="margin-top: 20px;">
      <div slot="header" class="flex justify-between">
        <span>说明</span>
      </div>
      <el-form label-width="100px">
        <el-form-item label="金额">
          <span style="font-size: 14px; color: red;">{{downShopHouseOutManageInfo.totalMount}}</span>
        </el-form-item>
        <el-form-item label="退货说明">
          <el-input
            type="textarea"
            v-model="downShopHouseOutManageInfo.remark"
            placeholder="必填，请填写退货说明"
            maxlength="250"
            show-word-limit
          ></el-input>
        </el-form-item>
        <el-form-item>
          <el-button type="primary" @click="_doInoutOrder()">
            <i class="el-icon-check"></i>提交
          </el-button>
          <el-button type="warning" @click="_goBack()" style="margin-left: 20px;">
            <i class="el-icon-close"></i>取消
          </el-button>
        </el-form-item>
      </el-form>
    </el-card>

    <choose-inout-order
      ref="chooseInoutOrder"
      @chooseInoutOrder="handleChooseInoutOrder"
    ></choose-inout-order>
  </div>
</template>

<script>
import { saveInoutOrder, queryInoutOrderProduct } from '@/api/goods/downShopHouseOutManageApi'
import { getShopId } from '@/api/shop/shopApi'
import ChooseInoutOrder from '@/components/goods/chooseInoutOrder/chooseInoutOrder'

export default {
  name: 'DownShopHouseOutManage',
  components: {
    ChooseInoutOrder
  },
  data() {
    return {
      downShopHouseOutManageInfo: {
        inoutOrderProducts: [],
        remark: '',
        orderType: '20000',
        orderId: '',
        totalMount: 0.0,
        relOrderId: '',
        shopId: ''
      },
      total: 0,
      pageSize: 15
    }
  },
  created() {
    this.downShopHouseOutManageInfo.shopId = getShopId()
  },
  methods: {
    _openAddShopHouseModal() {
      this.$refs.chooseInoutOrder.open({
        state: '8008'
      })
    },
    handleChooseInoutOrder(product) {
      this.downShopHouseOutManageInfo.orderId = product.orderId
      this.downShopHouseOutManageInfo.relOrderId = product.orderId
      this._listInoutOrderProduct()
    },
    async _listInoutOrderProduct() {
      try {
        const res = await queryInoutOrderProduct({
          page: 1,
          row: 50,
          orderId: this.downShopHouseOutManageInfo.orderId,
          shopId: this.downShopHouseOutManageInfo.shopId
        })
        this.downShopHouseOutManageInfo.inoutOrderProducts = res.data
      } catch (error) {
        console.error('获取订单商品失败:', error)
      }
    },
    async _doInoutOrder() {
      const _inoutOrderProducts = this.downShopHouseOutManageInfo.inoutOrderProducts
      if (_inoutOrderProducts.length < 1) {
        this.$message.warning('请选择商品')
        return
      }
      if (!this.downShopHouseOutManageInfo.remark) {
        this.$message.warning('退货说明不能为空')
        return
      }

      try {
        for (const item of _inoutOrderProducts) {
          if (!item.count || item.count <= 0) {
            this.$message.warning('请输入正确的数量')
            return
          }
          if (parseInt(item.count) > parseInt(item.prodCount)) {
            this.$message.warning('退货数量不能大于进库数量')
            return
          }
        }

        const res = await saveInoutOrder(this.downShopHouseOutManageInfo)
        if (res.code === 0) {
          this.$message.success(res.msg)
          this._goBack()
        } else {
          this.$message.error(res.msg)
        }
      } catch (error) {
        console.error('提交退货订单失败:', error)
        this.$message.error('提交退货订单失败')
      }
    },
    _goBack() {
      this.$router.go(-1)
    },
    _deleteProduct(inoutOrderProduct) {
      const index = this.downShopHouseOutManageInfo.inoutOrderProducts.indexOf(inoutOrderProduct)
      if (index > -1) {
        this.downShopHouseOutManageInfo.inoutOrderProducts.splice(index, 1)
      }
    },
    _caculTotalMount() {
      let total = 0
      try {
        this.downShopHouseOutManageInfo.inoutOrderProducts.forEach(item => {
          if (!isNaN(item.count) && !isNaN(item.price)) {
            total += parseFloat(item.count) * parseFloat(item.price)
          } else {
            throw new Error('请输入正确的数字')
          }
        })
        this.downShopHouseOutManageInfo.totalMount = total.toFixed(2)
      } catch (error) {
        this.downShopHouseOutManageInfo.totalMount = '请输入正确的数字'
      }
    },
    handleCurrentChange(val) {
      console.log(val)
    }
  }
}
</script>

<style scoped>
.box-card {
  margin-bottom: 20px;
}
</style>